import { render } from "./Adjustments.vue?vue&type=template&id=7ac521d6&scoped=true"
import script from "./Adjustments.vue?vue&type=script&lang=js"
export * from "./Adjustments.vue?vue&type=script&lang=js"

import "./Adjustments.vue?vue&type=style&index=0&id=7ac521d6&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac521d6"]])

export default __exports__